// extracted by mini-css-extract-plugin
export default {"disable-scroll":"LocationDetailsRepeater_disable-scroll__3UYol","add":"LocationDetailsRepeater_add__P8pMY"};